export default "__VITE_ASSET__B7$6l6dy__"